export var FilterSelectFieldEnum;
(function (FilterSelectFieldEnum) {
    FilterSelectFieldEnum["ThematiquesProjet"] = "thematique_du_projet";
    FilterSelectFieldEnum["ObjectifsProjet"] = "objectif_du_projet";
    FilterSelectFieldEnum["PublicConcerne"] = "public_concerne";
    FilterSelectFieldEnum["PartenaireDuProjet"] = "partenaire_du_projet";
})(FilterSelectFieldEnum || (FilterSelectFieldEnum = {}));
